//
// Copyright (c) 2011-2019 by Curalate, Inc.
//

import React from 'react';
import styled from 'styled-components';

import { PrimaryAnchor } from '@components/atoms/anchor/Anchor';
import { PrimaryButton } from '@components/atoms/button/Button';
import Icon from '@components/atoms/icon/Icon';
import { SubtitleText } from '@components/atoms/text/Text';

interface Props {
  errorMessage: string;
  errorDescription?: string;
  buttonText?: string;
  hrefText?: string;
  hrefLink?: string;
  onButtonClick?: () => void;
}

export const ValidationErrorLayout = ({
  errorMessage,
  errorDescription,
  buttonText,
  hrefText,
  hrefLink,
  onButtonClick,
}: Props) => {
  return (
    <Container>
      <AlarmIcon name='alarm' />
      <StyledSubtitleText>{errorMessage}</StyledSubtitleText>
      {errorDescription && <StyledBodyText>{errorDescription}</StyledBodyText>}
      {hrefText && (
        <StyledPrimaryAnchor target='_blank' href={hrefLink}>
          {hrefText}
        </StyledPrimaryAnchor>
      )}
      <PrimaryButton onClick={onButtonClick}>{buttonText}</PrimaryButton>
    </Container>
  );
};

const AlarmIcon = styled(Icon)`
  color: ${({ theme }) => theme.colors.gray4};
  margin-bottom: ${({ theme }) => theme.spacings[3]};
  && svg {
    width: ${({ theme }) => theme.spacings[5]};
    height: ${({ theme }) => theme.spacings[5]};
  }
`;

const StyledPrimaryAnchor = styled(PrimaryAnchor)(
  ({ theme }) => `
  margin-bottom: ${theme.spacings[3]};
`,
);

const StyledSubtitleText = styled(SubtitleText)(
  ({ theme }) => `
  margin-bottom: ${theme.spacings[3]};
`,
);

const StyledBodyText = styled(SubtitleText)(
  ({ theme }) => `
  margin-bottom: ${theme.spacings[3]};
`,
);

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
`;
